import React, { useState, useEffect, useRef } from "react";
import * as yup from "yup";
import DialogLayout from "../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
import { uploadCompanyProfileLogo } from "../../services/setup/company-profile/companyProfileService";
import { Typography } from "@material-ui/core";
import { Image } from "primereact/image";
import { Card } from "react-bootstrap";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../partials/layout/Avatar";
import ReactCrop from "react-image-crop";
import Swal from "sweetalert2";
const UploadCompanyProfileLogo = ({
  activeStep,
  handleBack,
  handleSkip,
  handleNext,
  companyProfile,
  companyProfileImgSrc,
  handleReloadCompanyProfile,
}) => {
  // const [companyProfileImgSrc, setCompanyProfileImgSrc] = useState(null);
  const [openUploadImage, setOpenUploadImage] = useState(false);
  const [imageSource, setImageSource] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [imageType, setImageType] = useState(null);
  const [imageCrop, setImageCrop] = useState({
    unit: "%",
    width: 30,
  });
  const [croppedImageUrl, setCroppedImageUrl] = useState(null);
  const imageRef = useRef(null);
  const fileInput = useRef(null);

  useEffect(() => {}, []);

  const licenseKeyFormSchema = yup.object().shape({
    licenseKey: yup.string().required("License Key is required for activation"),
  });
  return (
    <React.Fragment>
      <div className="horizontal-step-content">
        <div className="row justify-content-center">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="column">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Card>
                  <Card.Header>
                    <strong>Company Logo</strong>
                  </Card.Header>
                  <Card.Body>
                    <React.Fragment>
                      <Typography align="center">
                        <Image
                          src={
                            companyProfileImgSrc === null
                              ? createImageFromInitials(
                                  150,
                                  companyProfile.companyName,
                                  getRandomColor()
                                )
                              : companyProfileImgSrc
                          }
                          imageStyle={{
                            maxHeight: "100px",
                          }}
                          alt="Company Profile Logo"
                          fluid
                        />
                      </Typography>
                      <BootstrapTooltip title="Upload Company Logo">
                        <button
                          type="button"
                          onClick={handleOpenUploadImage}
                          className="btn btn-icon btn-label-success btn-circle mx-1 btn-md"
                        >
                          <i className="fas fa-camera"></i>
                        </button>
                      </BootstrapTooltip>
                    </React.Fragment>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openUploadImage}
        title="Upload Company Logo"
        onCloseDialog={handleCloseUploadImage}
        maxWIdth={fileInput.current != null ? "md" : "sm"}
      >
        <input
          className="form-control"
          type="file"
          accept="image/*"
          ref={fileInput}
          onChange={handleSelectImage}
          style={{ display: "none" }}
        />
        <div className="d-flex justify-content-center mb-5">
          <div className="column">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <React.Fragment>
                <Typography align="center">
                  <button
                    className="btn btn-primary btn-md btn-pill btn-bold mb-1"
                    onClick={() => fileInput.current.click()}
                  >
                    <i className="fas fa-mouse-pointer"></i>
                    Select File
                  </button>
                </Typography>
              </React.Fragment>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12">
              {fileInput.current != null ? (
                <React.Fragment>
                  <Typography align="center">{imageName}</Typography>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Typography align="center">No file chosen</Typography>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          {fileInput.current != null ? (
            <React.Fragment>
              <div className="col-6">
                <Card>
                  <Card.Header>
                    <Typography align="center" className="mb-1">
                      <strong>Crop Below Image</strong>
                    </Typography>
                  </Card.Header>
                  <Card.Body>
                    <Typography component="div" align="center">
                      {imageSource && (
                        <ReactCrop
                          src={imageSource}
                          crop={imageCrop}
                          ruleOfThirds={true}
                          onImageLoaded={handleImageLoaded}
                          onComplete={handleCropComplete}
                          onChange={handleCropChange}
                        />
                      )}
                    </Typography>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-6">
                <Card>
                  <Card.Header>
                    <Typography align="center" className="mb-1">
                      <strong> Cropped Image Preview</strong>
                    </Typography>
                  </Card.Header>
                  <Card.Body>
                    <Typography component="div" align="center">
                      {croppedImageUrl != null ? (
                        <Image
                          src={croppedImageUrl}
                          alt="Crop"
                          fluid
                          imageStyle={{
                            width: "50%",
                            height: "50%",
                          }}
                        />
                      ) : (
                        <Image
                          src="../../../invifo/illustrations/blank_image.png"
                          alt="Crop"
                          fluid
                          imageStyle={{
                            width: "50%",
                            height: "50%",
                          }}
                        />
                      )}
                    </Typography>
                  </Card.Body>
                </Card>
              </div>
            </React.Fragment>
          ) : null}
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseUploadImage}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="button"
            className="btn btn-success btn-md btn-pill btn-bold"
            onClick={async () => {
              if (croppedImageUrl != null && fileInput.current != null) {
                const filesData = new FormData();
                filesData.append("base64", croppedImageUrl);
                filesData.append("imageName", imageName);
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                })
                  .fire({
                    title: "Are you sure want to upload this Company Logo ?",
                    text:
                      "Please note that you are responsible for this action",
                    icon: "question",
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, upload it`,
                    cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                    reverseButtons: true,
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      uploadCompanyProfileLogo(filesData).then((response) => {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Uploaded",
                          html: response.data.message,
                          icon: "success",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });
                        handleReloadCompanyProfile();
                        handleCloseUploadImage();
                      });
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Cancelled",
                        text: "No change has been made",
                        icon: "info",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                    }
                  });
              } else {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Failed",
                  text: "Upload & Crop your Company Logo first before saving",
                  icon: "error",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            }}
          >
            <i className="fas fa-upload"></i>
            Upload
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogActions>
        <button
          type="button"
          className="btn btn-warning btn-md btn-pill btn-bold"
          onClick={handleBack}
          disabled={activeStep === 0}
        >
          <i className="fas fa-arrow-circle-left"></i>
          Back
        </button>
        <button
          type="button"
          className="btn btn-success btn-md btn-pill btn-bold"
          onClick={async () => {
            if (companyProfileImgSrc === null) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text:
                  "You need to upload your Company Logo first before saving",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            } else {
              handleNext();
            }
          }}
          // onClick={handleNext}
          // disabled={companyProfileImgSrc === null}
        >
          <i className="fas fa-check-circle"></i>
          Finish
        </button>
      </DialogActions>
    </React.Fragment>
  );

  async function handleOpenUploadImage() {
    setImageCrop({
      unit: "%",
      width: 30,
    });
    setImageSource(null);
    setImageName(null);
    setImageType(null);
    setCroppedImageUrl(null);
    setOpenUploadImage(true);
  }

  async function handleCloseUploadImage() {
    setOpenUploadImage(false);
  }

  async function handleSelectImage(e) {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImageSource(reader.result);
        setImageName(fileInput.current.files[0].name);
        setImageType(fileInput.current.files[0].type);
      });
      reader.readAsDataURL(e.target.files[0]);
      setCroppedImageUrl(null);
    }
  }

  async function handleImageLoaded(image) {
    imageRef.current = image;
    return false; // Return false when setting crop state in here.
  }

  async function handleCropComplete(crop) {
    makeClientCrop(crop);
  }

  async function handleCropChange(imageCrop, percentCrop) {
    setImageCrop(percentCrop);
  }

  async function makeClientCrop(crop) {
    if (imageRef.current && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(
        imageRef.current,
        crop,
        "newFile.jpeg"
      );
      setCroppedImageUrl(croppedImageUrl);
    }
  }

  async function getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = Math.ceil(crop.width * scaleX);
    canvas.height = Math.ceil(crop.height * scaleY);
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );
    return canvas.toDataURL(imageType);
  }
};

export default UploadCompanyProfileLogo;
